export default "__VITE_ASSET__gojwXOFZ__"